import clsx from "clsx";
import { isEmpty } from "lodash";
import React from "react";
import { useDropdown } from "../../../common/components/dropdown/useDropdown";
import useRoleDescriptions from "../../../common/roles/useRoleDescriptions";
import { CriterionLabel } from "./common/CriterionLabel";
import useDropdownPosition from "./useDropdownPosition";

interface RestrictedCriterionProps {
	label: string;
	prefix?: string;
	quickSearch: boolean;
	roles: string[];
}

export function RestrictedCriterion({
	label,
	prefix,
	quickSearch,
	roles,
}: RestrictedCriterionProps) {
	const { dropdownRef, dropdownIsOpened, onDropdownToggle } = useDropdown();
	const {
		isDropdownBelowViewport,
		isDropdownRightOfViewport,
		isDropdownHidden,
	} = useDropdownPosition(dropdownRef, dropdownIsOpened, quickSearch);
	const { roleDescriptions } = useRoleDescriptions();

	const packages = roles.map((role, index) => {
		if (index > 0 && !isEmpty(roleDescriptions)) {
			return ` or ${roleDescriptions[role]}`;
		}

		return roleDescriptions[role];
	});

	const content = (
		<>
			<p>Requires {packages} subscription.</p>
			<a href="/account-management/subscription">Add to Subscription</a>
		</>
	);

	if (!quickSearch) {
		return (
			<div className="criterion criterion-restricted">
				<section className="criterion-restricted__content">
					<p className="title">{label}</p>
					{content}
				</section>
			</div>
		);
	}

	return (
		<div
			ref={dropdownRef}
			className="criterion dropdown criterion-restricted"
		>
			<button
				type="button"
				className="dropdown-toggle"
				aria-expanded={dropdownIsOpened}
				onClick={onDropdownToggle}
			>
				<CriterionLabel label={label} prefix={prefix} />
			</button>

			<div
				className={clsx("dropdown-menu", {
					"dropdown-menu--opened": dropdownIsOpened,
					"dropdown-menu--inverted-y": isDropdownBelowViewport,
					"dropdown-menu--inverted-x": isDropdownRightOfViewport,
					"dropdown-menu--hidden": isDropdownHidden,
				})}
				data-criterion={true}
				tabIndex={-1}
			>
				{content}
			</div>
		</div>
	);
}
